var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Actor_ } from '../../../../../components/actor/Actor_';
let DraftCenterQuestionScene = class DraftCenterQuestionScene extends React.PureComponent {
    render() {
        const { question } = this.props;
        return React.createElement(Actor_, { actor: question });
    }
    componentDidMount() {
        console.timeEnd('FROM BOOT_CLIENT to READY');
    }
};
DraftCenterQuestionScene = __decorate([
    observer
], DraftCenterQuestionScene);
export { DraftCenterQuestionScene };
